import React, { useState, useEffect, useRef } from "react";
import InvoiceForm from "./InvoiceForm";
import Pagination from "../../../utils/pagination/Pagination";
import { Trash2, SquarePen, Eye, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ProgressBar from "../../../utils/progressBar/ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { getInvoices } from "../../../redux/reduxApi/invoicesReduxApi";
import { countInvoices } from "../../../redux/api/invoicesApi/invoicesApi";
import { deleteInvoices } from "../../../redux/api/invoicesApi/invoicesApi";
import { deleteinvoicesAction } from "../../../redux/reduxSlice/InvoicesSlice";
import { getClient } from "../../../redux/reduxApi/clientReduxApi";
import { useNavigate } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td, TableContainer, Checkbox, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, Button, Spinner, ModalCloseButton } from "@chakra-ui/react";
import "./Invoice.css";
import EllipsisMenu from "../../../utils/EllipsisDropdown/EllipsisMenu";
import { formatDate } from "../../../utils/commonFunction/CommonFunction";
function InvoiceList(sidebarColor) {
  const desktopRef = useRef(null);
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [deleteInvoicesROWID, setDeleteInvoicesROWID] = useState("");
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [dataToEdit, setDataToEdit] = useState({});
  const [invoicesROWId, setInvoicesROWId] = useState("");
  const [invoicesId, setInvoicesId] = useState("");
  const dispatch = useDispatch();

  const invoicesData = useSelector((state) => state?.invoices?.invoices);
  const clientData = useSelector((state) => state?.utils?.clientList); // Fetch client data from Redux store
  //to show add & delete button according to permissions
  const permissions = localStorage.getItem("permissions");
  const filterData = JSON.parse(permissions);
  console.log("filterData", filterData);

  // Fetch invoices data
  useEffect(() => {
    setLoading(true);
    dispatch(getInvoices({ page: currentPage, limit: 30, size: 30 })) // Fetch invoices data with pagination
      .catch((error) => {
        console.error("Error fetching Invoices data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage, dispatch]);
  // Fetch client data
  useEffect(() => {
    dispatch(getClient()) // This will fetch client data and store it in Redux
      .catch((error) => {
        console.error("Error fetching Client data:", error);
      });
  }, [dispatch]);
  // Fetch total count
  const fetchTotalCount = async () => {
    try {
      const response = await countInvoices();
      console.log("API Response:", response.data);
      const count = parseInt(response.data.count, 10);
      setTotalCount(count);
    } catch (error) {
      console.error("Error fetching total Invoices count:", error);
    }
  };
  const handleNewData = () => {
    fetchTotalCount();
  };
  useEffect(() => {
    fetchTotalCount();
  }, []);

  // Handle row deletion
  const handleDelete = () => {
    setShowProgressBar(true);
    setLoading(true);
    const idsToDelete = selectedRows.length === 0 ? [deleteInvoicesROWID] : selectedRows;
    Promise.all(idsToDelete.map((id) => deleteInvoices(id)))
      .then(() => {
        setSelectedRows([]);
        dispatch(deleteinvoicesAction(idsToDelete));
        toast.success("Row deleted successfully");
        fetchTotalCount();
      })
      .catch(() => {
        toast.error("Row not deleted");
      })
      .finally(() => {
        setIsOpen(false);
        setDeleteInvoicesROWID("");
        setShowProgressBar(false);
        setLoading(false);
      });
  };

  // Modal for delete confirmation
  const openTrash = (ROWID) => {
    setDeleteInvoicesROWID(ROWID);
    setIsOpen(true);
  };

  const closeTrash = () => {
    setIsOpen(false);
    setDeleteInvoicesROWID("");
  };

  // Handle row selection
  const handleRowSelect = (ROWID) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows.includes(ROWID);
      const updatedRows = isSelected ? prevSelectedRows.filter((id) => id !== ROWID) : [...prevSelectedRows, ROWID];
      setSelectedRows(updatedRows);
      setInvoicesROWId(updatedRows.join(","));
      return updatedRows;
    });
  };

  // Handle "select all" functionality
  const handleSelectAllRows = () => {
    setSelectedRows((prevSelectedRows) => {
      const updatedRows = prevSelectedRows.length === invoicesData?.length ? [] : invoicesData.map((item) => item?.invoices?.ROWID);
      return updatedRows;
    });
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const clientName = (id) => {
    if (id) {
      const temp = clientData?.find((item) => item?.clients?.ROWID === id);
      return temp ? temp?.clients?.firstName || "N/A" : "N/A";
    } else {
      return "N/A";
    }
  };

  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      {showProgressBar && <ProgressBar colorScheme="pink" />}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody></ModalBody>
          <ModalFooter>
            <Button className="create-button" mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className="cancel-button" onClick={closeTrash}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <div>
        <div ref={desktopRef}>
          <div className="d-flex justify-content-end">
            {selectedRows.length === 0 && (
              <>
                {filterData?.find((mod) => mod.moduleName === "Invoice" && mod.add === true) && (
                  <button className="new-button mx-2" onClick={openDrawer}>
                    <Plus size="18px" />
                    <span className="ms-1">New</span>
                  </button>
                )}
              </>
            )}
          </div>
          {selectedRows.length > 0 && (
            <>
              {filterData?.find((mod) => mod.moduleName === "Invoice" && mod.delete === true) && (
                <button className="new-button mx-2" onClick={openTrash}>
                  <Plus size="18px" />
                  <span className="ms-1">Delete All</span>
                </button>
              )}
            </>
          )}
        </div>
        <div className="custom-scroll " style={{ minHeight: "75vh", overflow: "scroll" }}>
          <TableContainer
            className="card card-detail mt-1 scrollable-container"
            style={{ minHeight: "75vh", backgroundColor: "white", border: "none", position: "relative", overflowY: "scroll", scrollbarColor: "#A0AEC0 #EDF2F7", scrollbarWidth: "10px" }}
          >
            <Table variant="simple" size="sm">
              <Thead>
                <Tr className="tr-border">
                  <Th className="py-1 th-color">
                    <Checkbox isChecked={selectedRows.length === invoicesData?.length} onChange={handleSelectAllRows} />
                  </Th>
                  <Th className="py-1 th-color">Actions</Th>
                  <Th className="py-1 th-color">Customer Name</Th>
                  <Th className="py-1 th-color">Invoice</Th>
                  <Th className="py-1 th-color">Order Number</Th>
                  <Th className="py-1 th-color">Working Days</Th>
                  <Th className="py-1 th-color">Payment Terms</Th>
                  <Th className="py-1 th-color">Sales Person</Th>
                  <Th className="py-1 th-color">Franchisee Account</Th>
                  <Th className="py-1 th-color">Due Date</Th>
                  <Th className="py-1 th-color">Invoice Date</Th>
                  <Th className="py-1 th-color">Job Type</Th>
                  <Th className="py-1 th-color">S/O Date</Th>
                </Tr>
              </Thead>
              <Tbody>
                {invoicesData &&
                  invoicesData?.map((item, index) => (
                    <Tr key={index} className="tr-border" style={{ cursor: "pointer", position: "relative" }}>
                      <Td>
                        <Checkbox isChecked={selectedRows.includes(item?.invoices?.ROWID)} onChange={() => handleRowSelect(item?.invoices?.ROWID)} />
                      </Td>
                      {/* <Td>
                          <div className="d-flex gap-1">
                            <Link to="/invoice-detail-view" state={{ ROWID: item?.invoices?.ROWID }}>
                              <i style={{ cursor: 'pointer' }}>
                                <Eye color="#ff176b" size="16px" strokeWidth="1" />
                              </i>
                            </Link>
                            {filterData[11].moduleName === "Invoice" && filterData[11].modifyAll === true ?
                              <i onClick={() => {
                                openDrawer(item?.invoices); setDataToEdit(item?.invoices);
                                setIsUpdateMode(true);
                                setInvoicesId(item?.invoices?.ROWID);
                              }}
                                style={{ cursor: 'pointer' }} >
                                <SquarePen color="#ff176b" size="16px" strokeWidth="1" />
                              </i> : ""}

                            {filterData[11].moduleName === "Invoice" && filterData[11].delete === true ?
                              <i style={{ cursor: 'pointer' }}
                                onClick={(e) => {
                                  openTrash(e);
                                  setDeleteInvoicesROWID(item?.invoices?.ROWID);
                                }} >
                                <Trash2 color="#ff176b" size="16px" strokeWidth="1" />
                              </i> : ""}
                          </div>
                        </Td> */}
                      <Td style={{ width: "110px", textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
                        <EllipsisMenu
                          item={item}
                          onView={() => navigate("/invoice-detail-view", { state: { ROWID: item?.invoices?.ROWID } })}
                          onEdit={() => {
                            openDrawer(item.invoices);
                            console.log("item.invoices", item.invoices);
                            
                            setDataToEdit(item.invoices);
                            setIsUpdateMode(true);
                            setInvoicesId(item?.invoices?.ROWID);
                          }}
                          onDelete={() => {
                            openTrash();
                            setDeleteInvoicesROWID(item?.invoices?.ROWID);
                          }}
                          permissions={{
                            canEdit: filterData?.find((mod) => mod.moduleName === "Invoice" && mod.modifyAll === true),
                            canDelete: filterData?.find((mod) => mod.moduleName === "Invoice" && mod.delete === true),
                            canView: true, // Usually always true, but you can make this dynamic too
                          }}
                        />
                      </Td>
                      <Td className="font-colors"> {clientName(item?.invoices?.customerName)} </Td>
                      <Td className="font-colors">{item?.invoices?.invoice}</Td>
                      <Td className="font-colors">{item?.invoices?.orderNumber}</Td>
                      <Td className="font-colors">{item?.invoices?.workingDays}</Td>
                      <Td className="font-colors">{item?.invoices?.paymentTerms}</Td>
                      <Td className="font-colors">{item?.invoices?.salesPerson}</Td>
                      <Td className="font-colors">{item?.invoices?.franchiseeAccount}</Td>
                      <Td className="font-colors">{formatDate(item?.invoices?.dueDate)}</Td>
                      <Td className="font-colors">{formatDate(item?.invoices?.invoiceDate)}</Td>
                      <Td className="font-colors">{item?.invoices?.jobType}</Td>
                      <Td className="font-colors">{formatDate(item?.invoices?.soDate)}</Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
        <div className="footer">
          <div className="footer d-flex fixed-bottom start-20">
            <div className="total" style={{ marginLeft: "16%", marginTop: "15px" }}>
              <p className="fw-semibold">Total Count: {totalCount}</p>
            </div>

            <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
              <Pagination totalPages={Math.ceil(totalCount / 30)} onPageChange={setCurrentPage} />
            </div>
            <InvoiceForm
              closeDrawer={closeDrawer}
              isDrawerOpen={isDrawerOpen}
              isUpdateMode={isUpdateMode}
              invoicesId={invoicesId}
              invoicesROWId={invoicesROWId}
              setIsUpdateMode={setIsUpdateMode}
              dataToEdit={dataToEdit}
              onNewDataAdded={handleNewData}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default InvoiceList;
